import { useCallback, useRef } from '@max/max';
export function useThrottle(fn, delay, fastCallBack) {
    const lastCall = useRef(0);
    return useCallback((...args) => {
        const now = Date.now();
        if (now - lastCall.current >= delay) {
            fn(...args);
            lastCall.current = now;
        }
        else {
            fastCallBack();
        }
    }, [fn, delay]);
}
